import type { InsuranceOfferWithSelectedState } from '@backmarket/http-api/src/api-models/InsuranceOffer'

export function hasProtectionServiceOffers(
  insuranceOffers: InsuranceOfferWithSelectedState[],
): boolean {
  return insuranceOffers.some((offer) => offer.type === 'PROTECTION_SERVICE')
}
